import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App';
import router from './router';
import mitt from 'mitt';
import "bootstrap/dist/css/bootstrap.min.css"

const emitter = mitt();

createApp(App)
  .use(router)
  .use(Antd)
  .provide('emitter', emitter)
  .mount('#app');